import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { motion, AnimatePresence} from "framer-motion";
import { ModalBlur } from './ModalBlur';
import { ModalHeart } from './ModalHeart';
import { ModalFaq } from './ModalFaq';
import { ModalScoring } from './ModalScoring';
import { ModalRanking } from './ModalRanking';
import { ModalHand } from './ModalHand';
import { ModalExit } from './ModalExit';
import { ModalResign } from './ModalResign';
import { ModalDimPanel } from './ModalDimPanel';
import { ModalVideoDimPanel } from './ModalVideoDimPanel';
import { ModalPurchaseCancelled } from './ModalPurchaseCancelled';
import { ModalRewardVideo } from './ModalRewardVideo';
import { ModalSkipTutorial } from './ModalSkipTutorial';
import { Spinner } from './UI';
import { ModalHeartsZero } from './ModalHeartsZero';
import { ModalLanguage } from './ModalLanguage';
import { calcTextSize } from './UI';
import { ModalOpponentResigned } from './ModalOpponentResigned';
import { ModalPlayerIntro } from './ModalPlayerIntro';
import { ModalResume } from './ModalResume';
import { ModalRemoveOpponent } from './ModalRemoveOpponent';

const config = window.dodConfig;


const OverlaysPage = styled.div`
	/* padding-top: 36%; */
	display: block;
	/* background-color: rgba(0,0,0, 0.5); */
	position: absolute;
	top: 0;
	left: 0;
	z-index: 3000;
	height: 100%;
	width: 100%;
	pointer-events: none;
	user-select: none;
`

const DisplayBody = styled(motion.div)`
	height: 100%;
	width: 100%;
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	pointer-events: ${p=>p.noMouse ? 'none' : 'auto'};
	background: ${p => p.dim ? 'rgba(0,0,0,0.5)' : 'none'};
`

const Middle = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${p => config.isLandscape ? 30 : 50}%;
	width: 100%;
`

const textSize = 45;

const Resume = styled.div`
	top: 0;
	left: 0;
	text-align: center;
	margin-top: ${p => config.isLandscape ? 50 : 50}vh;
	width: 100%;
	position: absolute;
	font-size: ${p => calcTextSize(textSize)}px;
	line-height: ${p => calcTextSize(textSize)}px;
	text-transform: uppercase;
	display: block;
	white-space: nowrap;
	&:before {
		background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,232,66,1) 50%,rgba(255,157,2,1) 100%);
		background-clip: text;
		-webkit-background-clip: text;
		color: rgba(0,0,0,0);
		display: block;
		content: 'RESUMING';
	}
	&:after {
		background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,232,66,1) 50%,rgba(255,157,2,1) 100%);
		background-clip: text;
		-webkit-background-clip: text;
		color: rgba(0,0,0,0);
		display: block;
		content: 'PREVIOUS GAME…';
	}
`
const ResumeShadow = styled.div`
	top: 0;
	left: 0;
	text-align: center;
	margin-top: ${p => config.isLandscape ? 50 : 50}vh;
	width: 100%;
	position: absolute;
	font-size: ${p => calcTextSize(textSize)}px;
	line-height: ${p => calcTextSize(textSize)}px;
	text-transform: uppercase;
	display: block;
	white-space: nowrap;
	text-shadow: 2px 2px 2px rgba(0,0,0,0.5);
	&:before {
		color: rgba(0,0,0,0);
		display: block;
		content: 'RESUMING';
	}
	&:after {
		color: rgba(0,0,0,0);
		display: block;
		content: 'PREVIOUS GAME…';
	}
`

const ErrorMessage = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 16px;
	color: #000;
	align-items: center;
	justify-content: center;
	padding: 20px;
	margin: 20px;
	width: 90%;
	text-align: center;
	& img {
		width: 100%;
	}

`

class Display extends Component {
	render(){
		const variants = {
			visible: { opacity: 1 },
			hidden: { opacity: 0 },
		};
		return (
			<DisplayBody
				initial="hidden"
				animate="visible"
				exit={{opacity: 0}}
				variants={variants}
			>
				{this.props.children}
			</DisplayBody>
		);
	}
}

// const Version = styled.div`
// 	color: #666f96;
// 	font: 16px sans-serif;
// 	position: absolute;
// 	top: 10px;
// 	left: 0;
// 	pointer-events: none;
// 	display: none;
// `

@observer
export class Overlays extends Component {

	prevent(e){
		// e.preventDefault();
		e.stopPropagation();
	}

	render() {

		// if(store.errorMessage){
		// 	return (
		// 		<OverlaysPage style={{pointerEvents: 'auto'}}>
		// 			<AnimatePresence>
		// 				<Display	key="error" ></Display>
		// 				<Middle>
		// 					<ErrorMessage>
		// 						<ButtonMover onClick={() => {
		// 							window.restartWebview();
		// 						}}>
		// 							<img
		// 								draggable="false"
		// 								style={{
		// 									pointerEvents: 'all'
		// 								}}
		// 								alt="The game has encountered an error and cannot continue."
		// 								src={siuImage.connectionError}/>
		// 						</ButtonMover>
		// 					</ErrorMessage>
		// 				</Middle>
		// 			</AnimatePresence>
		// 		</OverlaysPage>
		// 	);
		// }
		if(store.unsupportedDevice){
			return (
				<OverlaysPage style={{pointerEvents: 'auto'}}>
					<AnimatePresence>
						<Display key="device" ></Display>
						<Middle style={{height: '100%'}}>
							<ErrorMessage>
								<img draggable="false" alt="Your device may not be supported." src="/assets/DeviceErrorMsg_R7.jpg"/>
							</ErrorMessage>
						</Middle>
					</AnimatePresence>
				</OverlaysPage>
			);
		}
		return (
			<OverlaysPage
				onClick={this.prevent}
				onMouseDown={this.prevent}
				onMouseUp={this.prevent}
				onTouchStart={this.prevent}
			>
				<AnimatePresence>
					{store.modal === 'opponentResigned' && (
						<Display key="opponentResigned" >
							<ModalOpponentResigned/>
						</Display>
					)}
					{store.modal === 'blur' && (
						<Display key="blur" >
							<ModalBlur/>
						</Display>
					)}
					{store.modal === 'settingsLanguage' && (
						<Display key="settingsLanguage" dim >
							<ModalLanguage/>
						</Display>
					)}
					{store.modal === 'learn' && (
						<Display key="learn" >
							<ModalFaq/>
						</Display>
					)}
					{store.modal === 'heart' && (
						<Display key="heart" >
							<ModalHeart/>
						</Display>
					)}
					{store.modal === 'heartszero' && (
						<Display key="heartszero" >
							<ModalHeartsZero/>
						</Display>
					)}
					{store.modal === 'scoring' && (
						<Display key="scoring" >
							<ModalScoring/>
						</Display>
					)}
					{store.modal === 'ranking' && (
						<Display key="ranking" >
							<ModalRanking/>
						</Display>
					)}
					{store.modal === 'hand' && (
						<Display key="hand" >
							<ModalHand/>
						</Display>
					)}
					{store.modal === 'exit' && (
						<Display key="exit" >
							<ModalExit/>
						</Display>
					)}
					{store.modal === 'resign' && (
						<Display key="resign" >
							<ModalResign/>
						</Display>
					)}
					{store.modal === 'resume' && (
						<Display key="resume" >
							<ModalResume/>
						</Display>
					)}
					{store.modal === 'dimPanel' && (
						<Display key="dimPanel" >
							<ModalDimPanel/>
						</Display>
					)}
					{store.modal === 'videoDimPanel' && (
						<Display key="videoDimPanel" >
							<ModalVideoDimPanel/>
						</Display>
					)}
					{store.modal === 'purchaseCancelled' && (
						<Display key="purchaseCancelled" >
							<ModalPurchaseCancelled/>
						</Display>
					)}
					{store.modal === 'rewardVideo' && (
						<Display key="rewardVideo" >
							<ModalRewardVideo/>
						</Display>
					)}
					{store.modal === 'skipTutorial' && (
						<Display key="skipTutorial" >
							<ModalSkipTutorial/>
						</Display>
					)}
					{store.modal === 'humanPlayersIntro' && (
						<Display key="skipTutorial" >
							<ModalPlayerIntro human/>
						</Display>
					)}
					{store.modal === 'botPlayersIntro' && (
						<Display key="skipTutorial" >
							<ModalPlayerIntro bot/>
						</Display>
					)}
					)}
					{store.modal === 'removeOpponent' && (
						<Display key="removeOpponent" >
							<ModalRemoveOpponent/>
						</Display>
					)}

					{store.spinner && <Display noMouse key="spinner"><Middle><Spinner/></Middle></Display>}
					{store.phaserLoading && store.gameFromResume && <Display key="resumemsg" ><Middle><ResumeShadow/><Resume/></Middle></Display>}
					{/* {(window.location.hostname === 'localhost' || window.location.hostname === 'doddev5.com') && (
						<Version key="debug">
							V0.260
							Balance: ${store.user.balance} /
							{window.location.hostname} /
							{store.activeMatch && (
								<span>
									Hand: {store.activeMatch.handNumber} /
									Rolls Remaining: {store.activeMatch.currentHand.rollsRemaining} /
									Hearts: {store.activeMatch.hearts}
								</span>
							)}
							{store.errorMessage}
						</Version>
					)} */}
				</AnimatePresence>
			</OverlaysPage>
		)
	}
}
